<template>
  <div class="grasp-input__wrapper">
    <div class="grasp-input__prepend" v-if="$slots['prepend']">
      <slot name="prepend" />
    </div>
    <slot :updatingStatus="updatingStatus">
      <BaseFloatingLabel v-if="label" :label="label"></BaseFloatingLabel>
      <input
          :class="inputClasses"
          :disabled="disabled"
          :type="type || 'text'"
          :placeholder="placeholder"
          :value="modelValue"
          :tabindex="tabindex"
          :maxlength="maxLength || 500"
          @input="updateValue($event)"
          @blur="$emit('blur', $event)"
          @focus="$emit('focus')"
          ref="inputRef"
      />
      <div class="grasp-input__loading-indicator" v-if="updatingStatus">
        <BaseLoader v-model="updatingStatus" />
      </div>
    </slot>
    <div class="grasp-input__append" v-if="$slots['append']">
      <slot name="append" />
    </div>
  </div>
</template>
<script>

import debounce from 'lodash/debounce';
import { ref, computed, onMounted, nextTick } from 'vue';

export default {
  emits: ['update:modelValue', 'update', 'blur', 'change', 'focus', 'blur'],
  props: {
    modelValue: {
      required: true,
    },
    type: String,
    maxLength: Number,
    placeholder: String,
    asynchronous: Boolean,
    tabindex: Number,
    bordered: {
      default: true,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    autoFocus: {
      default: false,
      type: Boolean
    },
    label: {
      default: null,
      type: String,
    }
  },
  setup(props, { emit }) {
    const updatingStatus = ref(null);

    const inputClasses = computed(() => {
      let classes = 'grasp-input__input'

      if(props.required) {
        classes += ' grasp-input__required'
      }

      if(props.bordered) {
        classes += ' grasp-input__bordered'
      }

      return classes
    })

    const updateValue = event => {
      const value = event.target.value;

      emit('update:modelValue', value);
      emit('change', value);

      if (!props.asynchronous) return;
      return debouncedUpdate(value);
    };

    const debouncedUpdate = debounce(newValue => {
      updatingStatus.value = 'updating';
      new Promise((done, fail) => {
        emit('update', {
          value: newValue,
          done,
          fail,
        });
      })
          .then(() => {
            updatingStatus.value = 'success';
          })
          .catch(() => {
            updatingStatus.value = 'error';
          });
    }, 250);

    const inputRef = ref(null);

    const focusInput = () => {
      inputRef.value.focus();
    };

    const blurInput = () => {
      inputRef.value.blur();
    };

    const isInFocus = () => document.activeElement === inputRef.value;

    onMounted(async () => {
      if(props.autoFocus) {
        await nextTick()
        focusInput()
      }
    })

    return {
      updateValue,
      updatingStatus,
      inputRef,
      focusInput,
      blurInput,
      isInFocus,
      inputClasses,
    };
  },
};
</script>
<style lang="scss" scoped>
    .grasp-input {

      &__wrapper {
        //width: 100%;
      }
      &__bordered {
        padding: 12px 9px;
        box-sizing: border-box;
        border: 1px solid var(--skeleton-color);
        border-radius: 5px;
      }
      &__required::placeholder {
        opacity: 0.55;
      }

      &__append {
        display: flex;
        align-items: center;
      }
    }
</style>